import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import GlobalLoader from "./CommonC/GlobalLoader";
import { useSelector, useDispatch } from "react-redux";
import ShareProjectModal from "./CommonC/ShareProjectModal";
import EditModal from "./CommonC/EditModal";
import { makeStyles, withStyles } from "@mui/styles";
import Modal from "./CommonC/Modal";


import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ShareIcon from "@mui/icons-material/Share";

import { useNavigate } from "react-router-dom";
import Navbar from "./CommonC/Navbar";
import { baseURL } from "../Config/config";

import bg from "../images/AI.jpg"; // your bg image
import Selexlogo from "../images/SelexMB Final.png";
import SearchIcon from "@mui/icons-material/Search";
import { TextField } from "@mui/material";
import SelexSolNavbar from "./CommonC/SelexSolNavbar";


const NewProject = () => {
  const navigate = useNavigate();
  const [isModal, setIsModal] = React.useState(false);
  const [iseditModal, setIseditModal] = React.useState(false);

  const [projectDetails, setProjectDetails] = React.useState([]);
  const [getLoader, setGetLoader] = React.useState(false);
  const [shareModal, setShareModal] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [shareProjectName, setShareProjectName] = React.useState("");
  const [shareProjectID, setShareProjecID] = React.useState("");
  const [editProjectName, setEditProjectName] = React.useState("");
  const [editProjectID, setEditProjectID] = React.useState("");
  const [editClientName, setEditClientName] = React.useState("");
  const [editObjective, setEditObjective] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [searchProject, setSearchProject] = useState("");

  


  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const [open, setOpen] = React.useState(false);
  const [timer, setTimer] = React.useState(null);
  const [message, setmessage] = React.useState("");


  const handleClickOpen = () => {
    setOpen(true);
    setTimer(
      setTimeout(() => {
          setOpen(false);
      }, 2500)
  );

  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleeditClose = () => {
    setIseditModal(false);
  };
  const handleeditOpen = () => {
    setIseditModal(true);
  };
  // ADD THIS FILTER
const filteredProjects =
  projectDetails?.filter((item) =>
    item.projectName
      ?.toLowerCase()
      .includes(searchProject.toLowerCase())
  ) || [];


  const getAllProjects = async (id) => {
    setGetLoader(true);
    const token = sessionStorage.getItem("usertoken");
    const options = {
      method: "GET",
      headers: { "Content-Type": "application/json", token: token },
    };

    try {
      const result = await fetch(`${baseURL}/allprojects`, options);
      let res = await result.json();
      if (!res.code) {
        setGetLoader(false);
        return;
      }
      // getProjectDetails();
      setGetLoader(false);
      setProjectDetails([...res.data]);
    } catch (error) {
      setGetLoader(false);
      console.log("error", error);
    }
  };

  React.useEffect(() => {
    getAllProjects();
  }, []);


 const deleteProject = async (id) => {
    let body = {
      projectID: id,
    };

    const token = sessionStorage.getItem("usertoken");

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json", Token: token },
      body: JSON.stringify(body),
    };
    try {
      let result = await fetch(`${baseURL}/deleteproject`, options);
      result = await result.json();
      getAllProjects();
    } catch (error) {
      console.log("error", error);
    }
  };


  const copyProject = async (id) => {
    let body = {
      projectID: id,
    };

    const token = sessionStorage.getItem("usertoken");

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json", Token: token },
      body: JSON.stringify(body),
    };
    try {
      let result = await fetch(`${baseURL}/copyproject`, options);
      result = await result.json();
      getAllProjects();
    } catch (error) {
      console.log("error", error);
    }
  };

  const toggleShareModal = (projectName, projectID) => {
    setShareModal(!shareModal);
    setShareProjecID(projectID);
    setShareProjectName(projectName);
  };

  console.log(iseditModal)
  const toggleEditModal = (projectName, projectID) => {
    console.log("inside")

    fetch(
      `${baseURL}/projecteditdetails?projectID=${projectID}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.message === 1) {
          console.log(data)
          setEditProjectName(data.projectName);
          setEditClientName(data.clientname);
          setEditObjective(data.objective);

          setEditProjectID(projectID)
          handleeditOpen()
        } else {
          console.log("");
        }
      })
      .catch((err) => {
        setGetLoader(false);
        console.log(err);
      });
  };

  const handleEditProject = async () => {
    const token = sessionStorage.getItem("usertoken");
    console.log("editProjectID",editProjectID)
    sessionStorage.setItem("projectID",editProjectID);
    sessionStorage.setItem("projectName",editProjectName);
    sessionStorage.setItem("loaded",true);


    const body = {
      editProjectID,
    editProjectName,
    editClientName,
    editObjective,
    time: new Date(),
    // projectID,
    
  };

    const options = {
      method: "POST",
      headers: { "Content-Type": "application/json", token: token },
      body: JSON.stringify(body),
    };

    try {
      let res = await fetch(`${baseURL}/editproject`, options);
      res = await res.json();
      if (res.code === 1) {
        setIsLoading(false);
        navigate("/newproject", { state: { loaded: true, ProjectID: editProjectID,projectName: editProjectName } });
        return;

      }
      
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleShareProject = async (value) => {
    const token = sessionStorage.getItem("usertoken");

    const body = {
      email,
      shareProjectName,
      shareProjectID,
      editAccess: value,
    };


  const options = {
      method: "POST",
      headers: { "Content-Type": "application/json", token: token },
      body: JSON.stringify(body),
    };

    try {
      let res = await fetch(`${baseURL}/shareproject`, options);
      res = await res.json();
      if (res.code === 1) {
        toggleShareModal();
        handleClickOpen();
        setmessage("Project Shared Successfully")
        return;
      }
      else if(res.code === 0){
        toggleShareModal();
        handleClickOpen();
        setmessage(res.message);
      }
      else if (res.code === 2){
        toggleShareModal();
        handleClickOpen();
        setmessage(res.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleNavigation = (projectID,projectName) => {
    navigate("/newproject", {
      state: {
        ProjectID: projectID,
        projectName:projectName,
        loaded: true,
      },
    });
  };

  const toggleModal = () => {
    return setIsModal(!isModal);
  };




return (
  <Box
    sx={{
      minHeight: "100vh",
      background:
        "#fff",
      position: "relative",
      overflow: "hidden",
      pb: 5,
    }}
  >
    <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")} />

    {/* TOP SECTION */}
    <Box
      sx={{
        width: "92%",
        maxWidth: "1250px",
        margin: "auto",
        mt: 4,
        position: "relative",
        zIndex: 2,
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
          mb: 3,
        }}
      >
        {/* LEFT */}
        <Box>
          
          <Typography
            sx={{
              fontSize: { xs: 28, md: 34 },
              fontWeight: 700,
              color: "#0078c9",
              letterSpacing: "-1px",
            }}
          >
            Projects List
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              color: "#64748b",
              mt: 0.5,
            }}
          >
            Manage and organize all your projects
          </Typography>
        </Box>

        {/* RIGHT */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          {/* TOTAL PROJECTS */}
          <Box
            sx={{
              height: "48px",
              px: 3,
              borderRadius: "14px",
              background: "#fff",
              border: "1px solid #dbe7f3",
              display: "flex",
              alignItems: "center",
              boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
            }}
          >
            <Typography
              sx={{
                fontSize: 14,
                color: "#64748b",
                mr: 1,
              }}
            >
              Total Projects:
            </Typography>

            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 700,
                color: "#0078c9",
              }}
            >
              {projectDetails?.length || 0}
            </Typography>
          </Box>

          {/* CREATE BUTTON */}
          <Button
            onClick={toggleModal}
            sx={{
              height: "48px",
              px: 4,
              borderRadius: "14px",
              textTransform: "none",
              fontWeight: 700,
              fontSize: 14,
              background:
                "linear-gradient(135deg, #0078c9 0%, #0078c9 100%)",
              boxShadow: "0 10px 25px rgba(0,120,201,0.25)",
              color: "#fff",
              "&:hover": {
                background:
                  "linear-gradient(135deg, #006eb7 0%, #008de6 100%)",
              },
            }}
          >
            + Create Project
          </Button>
        </Box>
      </Box>

      {/* TABLE CARD */}
      <Box
        sx={{
          background: "rgba(255,255,255,0.85)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          borderRadius: "26px",
          border: "1px solid rgba(255,255,255,0.4)",
          boxShadow: "0 20px 50px rgba(15,23,42,0.08)",
          overflow: "hidden",
        }}
      >
        {/* TOP BAR */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
            px: 3,
            py: 2.5,
            borderBottom: "1px solid #edf2f7",
            background:
              "linear-gradient(to right, rgba(0,120,201,0.04), rgba(255,255,255,0.5))",
          }}
        >
          {/* TITLE */}
          <Box>
            <Typography
              sx={{
                fontSize: 22,
                fontWeight: 700,
                color: "#0f172a",
              }}
            >
              Project Workspace
            </Typography>

            <Typography
              sx={{
                fontSize: 13,
                color: "#64748b",
                mt: 0.5,
              }}
            >
              View, edit, copy and manage your projects
            </Typography>
          </Box>

          {/* SEARCH */}
          <Box>
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 600,
                color: "#475569",
                mb: 1,
                ml: 0.5,
              }}
            >
              Search Projects
            </Typography>

            <TextField
              placeholder="Search by project name..."
              value={searchProject}
              onChange={(e) =>
                setSearchProject(e.target.value)
              }
              size="small"
              InputProps={{
                startAdornment: (
                  <SearchIcon
                    sx={{
                      color: "#94a3b8",
                      mr: 1,
                      fontSize: 20,
                    }}
                  />
                ),
              }}
              sx={{
                width: "320px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "14px",
                  background: "#fff",
                  height: "45px",
                  fontSize: 14,
                },
                "& .MuiOutlinedInput-root fieldset": {
                  borderColor: "#dbe7f3",
                },
                "& .MuiOutlinedInput-root:hover fieldset": {
                  borderColor: "#0078c9",
                },
                "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                  borderColor: "#0078c9",
                  borderWidth: "2px",
                },
              }}
            />
          </Box>
        </Box>

        {/* TABLE */}
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            background: "transparent",
            maxHeight: "65vh",
          }}
        >
          <Table
            stickyHeader
            sx={{
              minWidth: 850,
              "& .MuiTableCell-root": {
                borderBottom: "1px solid #edf2f7",
              },
            }}
          >
            {/* TABLE HEADER */}
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "#0078c9",
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: 13,
                    py: 2,
                  }}
                >
                  PROJECT NAME
                </TableCell>

                <TableCell
                  sx={{
                    backgroundColor: "#0078c9",
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: 13,
                  }}
                >
                  LAST MODIFIED
                </TableCell>

                <TableCell
                  sx={{
                    backgroundColor: "#0078c9",
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: 13,
                  }}
                >
                  EDIT
                </TableCell>

                <TableCell
                  sx={{
                    backgroundColor: "#0078c9",
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: 13,
                  }}
                >
                  COPY
                </TableCell>

                <TableCell
                  sx={{
                    backgroundColor: "#0078c9",
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: 13,
                  }}
                >
                  DELETE
                </TableCell>

                <TableCell
                  sx={{
                    backgroundColor: "#0078c9",
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: 13,
                  }}
                >
                  SHARE
                </TableCell>
              </TableRow>
            </TableHead>

            {/* TABLE BODY */}
            <TableBody>
              {filteredProjects.length > 0 ? (
                filteredProjects.map((item) => {
                  const dateStr = new Date(item.time)
                    .toDateString()
                    .substr(4);

                  return (
                    <TableRow
                      key={item.projectID}
                      hover
                      sx={{
                        transition: "0.25s",
                        "&:hover": {
                          backgroundColor: "#f8fbff",
                        },
                      }}
                    >
                      {/* PROJECT NAME */}
                      <TableCell>
                        <Typography
                          onClick={() =>
                            handleNavigation(
                              item.projectID,
                              item.projectName
                            )
                          }
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: "#0f172a",
                            cursor: "pointer",
                            transition: "0.2s",
                            "&:hover": {
                              color: "#0078c9",
                            },
                          }}
                        >
                          {item.projectName}
                        </Typography>
                      </TableCell>

                      {/* DATE */}
                      <TableCell>
                        <Typography
                          sx={{
                            fontSize: 13,
                            color: "#64748b",
                          }}
                        >
                          {dateStr}
                        </Typography>
                      </TableCell>

                      {/* EDIT */}
                      <TableCell>
                        <IconButton
                          onClick={() =>
                            toggleEditModal(
                              item.projectName,
                              item.projectID
                            )
                          }
                          sx={{
                            background: "#e0f2fe",
                            "&:hover": {
                              background: "#bae6fd",
                            },
                          }}
                        >
                          <EditIcon
                            sx={{
                              color: "#0284c7",
                              fontSize: 18,
                            }}
                          />
                        </IconButton>
                      </TableCell>

                      {/* COPY */}
                      <TableCell>
                        <IconButton
                          onClick={() =>
                            copyProject(item.projectID)
                          }
                          sx={{
                            background: "#ecfeff",
                            "&:hover": {
                              background: "#cffafe",
                            },
                          }}
                        >
                          <ContentCopyIcon
                            sx={{
                              color: "#0891b2",
                              fontSize: 18,
                            }}
                          />
                        </IconButton>
                      </TableCell>

                      {/* DELETE */}
                      <TableCell>
                        <IconButton
                          onClick={() =>
                            deleteProject(item.projectID)
                          }
                          sx={{
                            background: "#fef2f2",
                            "&:hover": {
                              background: "#fee2e2",
                            },
                          }}
                        >
                          <DeleteIcon
                            sx={{
                              color: "#dc2626",
                              fontSize: 18,
                            }}
                          />
                        </IconButton>
                      </TableCell>

                      {/* SHARE */}
                      <TableCell>
                        <IconButton
                          onClick={() =>
                            toggleShareModal(
                              item.projectName,
                              item.projectID
                            )
                          }
                          sx={{
                            background: "#eff6ff",
                            "&:hover": {
                              background: "#dbeafe",
                            },
                          }}
                        >
                          <ShareIcon
                            sx={{
                              color: "#2563eb",
                              fontSize: 18,
                            }}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={6}>
                    <Box
                      sx={{
                        py: 8,
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 18,
                          fontWeight: 600,
                          color: "#64748b",
                        }}
                      >
                        No Projects Found
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: 13,
                          color: "#94a3b8",
                          mt: 1,
                        }}
                      >
                        Try searching with another project name
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>

    <Modal isModal={isModal} toggleModal={toggleModal} />

    <EditModal
      isModal={iseditModal}
      setIseditModal={setIseditModal}
      handleeditClose={handleeditClose}
      toggleModal={toggleEditModal}
      handleEditProject={handleEditProject}
      editProjectName={editProjectName}
      editClientName={editClientName}
      editObjective={editObjective}
      setEditClientName={setEditClientName}
      setEditProjectName={setEditProjectName}
      setEditObjective={setEditObjective}
      setEditProjectID={setEditProjectID}
      editProjectID={editProjectID}
    />

    <ShareProjectModal
      isModal={shareModal}
      handleShareProject={handleShareProject}
      setEmail={setEmail}
      email={email}
      toggleModal={toggleShareModal}
    />

    {getLoader && <GlobalLoader />}
  </Box>
);
};

export default NewProject;